const {REACT_APP_BASE_API_URL, REACT_APP_BASE_API_SSL, REACT_APP_BASE_API_WS, REACT_APP_ANALYZE_API_URL} = process.env;

const UrlDev = {
    SIA_API_HOST: REACT_APP_BASE_API_URL,
    FIRST_ROUTE: 'sia',
    LOGIN_ROUTE: 'core',
    TAGGING_ROUTE: 'tagging_platform',
    MANAGEMENT_ROUTE: 'management',
    VA_ROUTE: 'va',
    DEPLOY: 'ai_services',
    EVALUATION: 'evaluation',
    TRAINING_ROUTE: 'training',
    ACCURACY_ROUTE: 'verification/accuracy',
    CLASSIFICATION_ROUTE: 'training',
    DATA_MANAGEMENT_ROUTE: 'data_management',
    AUTOMATED_MODELS: 'automated_models',
    SAML: 'saml',
    SSL: REACT_APP_BASE_API_SSL,
    WS: REACT_APP_BASE_API_WS,
    ANALYZE: REACT_APP_ANALYZE_API_URL
};

enum GET_REQ{
    LOGIN= 'login/',
    FEATURES= 'get_features/',
    SESSION= 'session_id/',
    SESSION_STORAGE='session_storage/',
    PROJECTS= 'get_projects/',
    DISCONNECT_TAB='disconnect_tab/',
    DISCONNECT='disconnect/',
    TOKEN_ANALYZE='session_jwt_token/',
    CONNECT='connect/',
    PROJECT_LIST='projects_list/',
    PRODUCTION='get_production_projects/',
    GET_SETTINGS='tagging_platform_settings/',
    PROJECT_DETAILS= 'tagging_projects/',
    PROJECT_DETAILS_VIDEOS='video_projects/',
    DOWNLOAD_PROJECT='download_sia_project/',
    CLASSIFICATION_GET_PROJECT='training_projects/',
    PROJECT_DETAILS_DEBUG= 'analyze_debug/',
    GET_ALL_PROJECTS='all_data_projects/',
    GET_PROJECT_DETAILS='get_data_project_details/',
    GET_CONFIGURATION='data_management_configuration/',
    GET_ACCOUNT_QUOTAS='get_account_quotas/',
    GET_FEATURE_VERSIONS ='request_versions/',
    GET_PROJECT_FEATURES='request_features/',
    GET_ACTIVE_FEATURE='request_training_status/',
    CLOSE_NOTIFICATION_TRAINING='update_notify/',
    CANCEL_TRAINING = 'cancel_training/',
    GET_ALL_FEATURES='all_account_features_data/',
    GET_HISTORY_TRAINING='training_history/',
    GET_SAML_URL='connect_crm/',
    VI_FEATURES='get_vi_features_permission/',
    GET_RANDOM_IMAGES='get_random_sniffer_images/',
    GET_SOURCES_WITH_DATA='get_sources_with_data/',
    GET_AUTO_PROJECT_STATUS='get_project_status/'
}

enum POST_REQ{
    PROJECT_DETAILS= 'tagging_projects/',
    DISCONNECT_TAB='disconnect_tab/',
    ACCURACY= 'accuracy/',
    DISCONNECT='disconnect/',
    CONFIGURATION_UPLOAD_HDF = 'upload_hdf5/',
    LOGS='log/',
    PROJECT_DETAILS_VIDEOS='video_projects/',
    SESSION_STORAGE='session_storage/',
    SESSION= 'session_id/',
    PROJECT_DETAILS_CLASSIFICATION ='training_projects/',
    GET_SIGNED='get_signed_url_upload/',
    GET_SIGNED_VIDEOS='get_signed_url/',
    SIGNED_URL='get_files_signed_urls/',
    CREATE_NEW_PROJECT= 'create_data_project/',
    EDIT_PROJECT= 'edit_data_project/',
    DELETE_TAG='delete_tag/',
    RUN_AUTO_CLASSIFIER = 'run_automated_classifier/',
    DELETE_PROJECT='delete_data_project/',
    ADD_FOLDER='add_folder/',
    VERIFY_FILES='verify_files/',
    UPDATE_FILE_STATUS='update_files_upload_status/',
    DELETE_FILES='delete_files/',
    DELETE_FOLDERS='delete_folders/',
    GET_FOLDER_DETAILS='get_folder_details/',
    GET_IMAGES_AND_PROJECT_DATA='open_tagging_page/',
    GET_TAGGING_NEXT_PAGE='open_tagging_next_page/',
    SAVE_IMAGE='save_image/',
    SAVE_TAGS_FOLDERS='add_tags_to_files/',
    GET_FILE_DETAILS='get_file_details/',
    UPDATE_VIDEO='video_uploaded/',
    TRACK_VIDEO='track_video/',
    CANCEL_TRACKING='cancel_tracking/',
    VIEW_TRACK_IMAGES='get_tracked_images/',
    START_TRAINING = 'execute_training/',
    SAVE_FEATURE_DRAFT = 'save_feature_as_draft/',
    PRE_EVALUATE = 'pre_evaluate_feature/',
    DEPLOY_UPDATE='update_deployed_features_to_service/',
    EDIT_FOLDER_NAME='edit_folder_name/',
    GET_MANUAL_REFINEMENT='get_manual_refinement/',
    UPDATE_MANUAL_REFINEMENT='update_manual_refinement/',
    COPY_RANDOM_IMAGES='copy_random_images/',
    REMOVE_RANDOM_IMAGE='remove_random_image/',
    OTT_REDEEM='ott_redeem/',
    STOP_AUTO_PROJECT='stop_auto_project/',
    UPDATE_AUTO_CLASS_BATCH='update_auto_class_batch/',
    DELETE_SUB_CLUSTER='delete_sub_cluster/'
}
const CORE_PATH = {
    CONNECT: 'CONNECT',
    LOGIN: 'LOGIN',
    TOKEN_ANALYZE: 'TOKEN_ANALYZE',
    DISCONNECT: 'DISCONNECT',
    LOGS: 'LOGS',
    SESSION: 'SESSION',
    DISCONNECT_TAB: 'DISCONNECT_TAB',
    SESSION_STORAGE: 'SESSION_STORAGE',
    OTT_REDEEM: 'OTT_REDEEM'
};

const SAML_PATH = {
    GET_SAML_URL: 'GET_SAML_URL',
};

const MANAGE_PATH = {
    PROJECT_DETAILS_DEBUG: 'PROJECT_DETAILS_DEBUG',
    CONFIGURATION_UPLOAD_HDF: 'CONFIGURATION_UPLOAD_HDF',
    VI_FEATURES: 'VI_FEATURES'
};

const AUTO_CLASSIFICATION_PATH = {
    RUN_AUTO_CLASSIFIER: 'RUN_AUTO_CLASSIFIER',
    GET_AUTO_PROJECT_STATUS: 'GET_AUTO_PROJECT_STATUS',
    GET_MANUAL_REFINEMENT: 'GET_MANUAL_REFINEMENT',
    GET_RANDOM_IMAGES: 'GET_RANDOM_IMAGES',
    UPDATE_MANUAL_REFINEMENT: 'UPDATE_MANUAL_REFINEMENT',
    COPY_RANDOM_IMAGES: 'COPY_RANDOM_IMAGES',
    REMOVE_RANDOM_IMAGE: 'REMOVE_RANDOM_IMAGE',
    STOP_AUTO_PROJECT: 'STOP_AUTO_PROJECT',
    GET_SOURCES_WITH_DATA: 'GET_SOURCES_WITH_DATA',
    UPDATE_AUTO_CLASS_BATCH: 'UPDATE_AUTO_CLASS_BATCH',
    DELETE_SUB_CLUSTER: 'DELETE_SUB_CLUSTER'
};

const DATA_MANAGEMENT_PATH = {
    GET_ALL_PROJECTS: 'GET_ALL_PROJECTS',
    CREATE_NEW_PROJECT: 'CREATE_NEW_PROJECT',
    GET_PROJECT_DETAILS: 'GET_PROJECT_DETAILS',
    EDIT_PROJECT: 'EDIT_PROJECT',
    DELETE_TAG: 'DELETE_TAG',
    DELETE_PROJECT: 'DELETE_PROJECT',
    GET_CONFIGURATION: 'GET_CONFIGURATION',
    GET_ACCOUNT_QUOTAS: 'GET_ACCOUNT_QUOTAS',
    ADD_FOLDER: 'ADD_FOLDER',
    VERIFY_FILES: 'VERIFY_FILES',
    SIGNED_URL: 'SIGNED_URL',
    UPDATE_FILE_STATUS: 'UPDATE_FILE_STATUS',
    DELETE_FILES: 'DELETE_FILES',
    GET_FOLDER_DETAILS: 'GET_FOLDER_DETAILS',
    DELETE_FOLDERS: 'DELETE_FOLDERS',
    EDIT_FOLDER_NAME: 'EDIT_FOLDER_NAME'
};

const TAGGING = {
    GET_IMAGES_AND_PROJECT_DATA: 'GET_IMAGES_AND_PROJECT_DATA',
    GET_FILE_DETAILS: 'GET_FILE_DETAILS',
    SAVE_IMAGE: 'SAVE_IMAGE',
    SAVE_TAGS_FOLDERS: 'SAVE_TAGS_FOLDERS',
    UPDATE_VIDEO: 'UPDATE_VIDEO',
    TRACK_VIDEO: 'TRACK_VIDEO',
    CANCEL_TRACKING: 'CANCEL_TRACKING',
    VIEW_TRACK_IMAGES: 'VIEW_TRACK_IMAGES',
    GET_TAGGING_NEXT_PAGE: 'GET_TAGGING_NEXT_PAGE'
};

const TRAINING = {
    GET_PROJECT_FEATURES: 'GET_PROJECT_FEATURES',
    GET_FEATURE_VERSIONS: 'GET_FEATURE_VERSIONS',
    GET_ACTIVE_FEATURE: 'GET_ACTIVE_FEATURE',
    START_TRAINING: 'START_TRAINING',
    SAVE_FEATURE_DRAFT: 'SAVE_FEATURE_DRAFT',
    PRE_EVALUATE: 'PRE_EVALUATE',
    CANCEL_TRAINING: 'CANCEL_TRAINING',
    CLOSE_NOTIFICATION_TRAINING: 'CLOSE_NOTIFICATION_TRAINING',
    GET_HISTORY_TRAINING: 'GET_HISTORY_TRAINING'
};

const DEPLOY = {
    GET_ALL_FEATURES: 'GET_ALL_FEATURES',
    DEPLOY_UPDATE: 'DEPLOY_UPDATE'
};

const EVALUATION_PATH = {
    ACCURACY: 'ACCURACY'
};

enum WS_RESPONSE_ROUTES{
    SAVE_TAG_CHANGES = 'uploadStatus',
    GET_PROJECT_PATCHES = 'getProjectPatchesMessage',
    DELETE_PATCH = 'deletePatch',
    ADD_PATCH = 'addPatchMessage',
    CREATE_SYNTHETIC_IMAGE = 'CreateSyntheticImageStatus',
    HITL_SAVE_TAG_CHANGES = 'listen_uploadStatus',
    TRAIN_STATUS = 'trainDeployStatus',
    AUTO_TAG_UPLOAD_STATUS = 'annotateStatus',
    AUTO_TAG_TASK_ID = 'autoTaggingTaskId',
    DOWNLOAD_PROJECT_TASK_ID = 'downloadProjectZipTaskId',
    SEGMENTHOR_TASK_ID = 'annotateVideoTaskId',
    EDIT_PROJECT_PARAMS = 'editProjectParamsDone',
    HEART_BEAT = 'heartBeat',
    DELETE_IMAGE = 'deleteInfo',
    DELETE_CLASS = 'delete_class',
    VIDEO_ANNOTATION_STATUE = 'VideoAnnotationStatus',
    IMAGE_ANNOTATION_STATUE = 'annotateStatusImage',
    ACCURACY_STATISTICS = 'AccuracyStatistics',
    MISSING_DATA = 'missingData',
    DELETE_PROJECT = 'deleteProjectDone',
    DELETE_MULTI_IMAGES = 'deleteMultipleImagesDone',
    ZIP_INFO = 'zipInfo',
    ZIP_FILE_STATUS = 'zipFileDone',
    VIDEO_FRAME = 'videoAnnotatedFrame',
    VIDEO_FIRST_FRAME = 'videoFirstFrame',
    CLASSIFICATION_SUMMARY='TrainingSessionDetails',
    TRAINING_ERROR='TrainingError',
    OPEN_PROJECT_DETAILS='OpenProjectDetails',
    START_UPLOAD_HDF5_CHUNKS ='redisKeyCreation',
    UPLOAD_HDF5_CHUNKS ='packetDataAdded',
    HDF5_HAS_UPLOADED = 'modelMetadata',
    GET_CONFIGURATION_INIT = 'featureList',
    CONFIGURATION_FEATURE_ADDED = 'featureAdded',
    CONFIGURATION_FEATURE_UPDATED = 'featureUpdate',
    FILE_UPLOADED_SUCCESSFULLY = 'uploadHdf5File',
    GET_CASCADE_MODES = 'cascadeAiModes',
    GET_SEGMENTATION_RATIOS = 'outputRatioOptions',
    GET_FEATURE_META='featureMetadata',
    GET_ALL_GROUPS = 'groupList',
    GROUP_ADDED = 'groupCreate',
    GROUP_UPDATED = 'groupUpdate'
}

enum WS_RESPONSE_STATUS {
    SUCCESS ='Success'
}


export default {
    timeOut: {
        NUMBER_OF_RETRIES: 3,
        TIME_DELAY: 4000
    },
    wsConfig: {
        MAX_NUMBER_OF_CONNECTIONS: 3,
        RECONNECT_DELAY: 10000
    },
    UrlDev,
    GET_REQ,
    WS_RESPONSE_STATUS,
    DEPLOY,
    POST_REQ,
    TRAINING,
    TAGGING,
    EVALUATION_PATH,
    MANAGE_PATH,
    DATA_MANAGEMENT_PATH,
    WS_RESPONSE_ROUTES,
    CORE_PATH,
    SAML_PATH,
    AUTO_CLASSIFICATION_PATH
};

